<template>
  <div>
    
  <a v-on:click="addNewDirectory()" class="float-end btn btn-sm btn-secondary"><i class="fas fa-folder"></i>&nbsp;{{ $t("generic.new-folder") }}</a>
    
    
    
    <FileChooser  class="float-end"
                  is-multiple
                  :is-add="true"
                  @multiple-files-chosen="addFiles($event, currentDir)"
                  accepted-extensions=""                             
      />
  <div class="float-start mt-2">
    <b>{{$t('generic.total-files')}}</b> {{fileCount}}, {{totalFilesSize}}
  </div>
  <div class="directory-breadcrumb"  >
    
    
    <!--
    <a v-on:click="addFiles()" class="float-end btn btn-sm btn-primary mx-1"><i class="fa-solid fa-file-circle-plus"></i>&nbsp;{{ $t("generic.add-files") }}</a>
    -->
    <div  class="directory-link-container"  v-if="directoryView" >
          <a class="directory-link" v-on:click="setDirectory('')"><i class="fas fa-home"></i></a>
          <span v-for="(val, key)  in currentDirParts" :key="val" >
            / 
            <a 
            v-if="currentDirParts.length != (key+1)"            
            class="directory-link" v-on:click="setDirectoryPart(key+1)">{{val}}</a>
            <span class="directory-link" v-if="currentDirParts.length == (key+1)">{{val}}</span>
          </span> 
    </div>
    <div v-if="!directoryView" >
      <a class="directory-link" >
        <i class="fas fa-list"></i> 
      </a>
    </div>
  </div>
  <table id="extracted-file-list" class="file-list table table-striped">
        <thead v-if="loadingAll">
            <tr> 
              <td><i>{{ $t("generic.loading") }}</i></td>
            </tr>
        </thead>
        
        <tbody id="fileTbody" v-if="!loadingAll">
          <!--
          <tr v-if="addDirectoryInput" > 
            <td>
                <i class="fas fa-folder"></i>&nbsp;&nbsp;<input :placeholder="$t('generic.enter-folder-name')" class="folder-input" type="text" v-model="newDirectoryName" ref="newDirectoryInput" v-on:keydown.enter="submitNewDirectory" v-on:keydown.esc="cancelNewDirectory">
                <button type="button" class="btn btn-sm btn-danger" v-on:click="cancelNewDirectory()"><i   class="float-end fas fa-times "  ></i></button>
                <button type="button" class="btn btn-sm btn-success" v-on:click="submitNewDirectory()"><i   class="float-end fa-solid fa-check "  ></i></button>
            </td>
          </tr>
          -->
        <tr v-if="addDirectoryInput">
            <td width="25">
              <i class="fas fa-folder"  aria-hidden="true"></i>
            </td>
            <td>
              <input style="width:100%" :placeholder="$t('generic.enter-folder-name')" class="folder-input" type="text" v-model="newDirectoryName" ref="newDirectoryInput" v-on:keydown.enter="submitNewDirectory" v-on:keydown.esc="cancelNewDirectory">
            </td>
            <td width="75" >
                <button type="button" class="btn btn-sm btn-danger" v-on:click="cancelNewDirectory()"><i   class="float-end fas fa-times "  ></i></button>
                <button type="button" class="btn btn-sm btn-success" v-on:click="submitNewDirectory()"><i   class="float-end fa-solid fa-check "  ></i></button>
            </td>
        </tr>


          <tr v-if="filteredFileListView.length == 0" > 
            <td colspan="3"><i>{{ $t("generic.no-files") }}</i></td>
          </tr>
          <tr v-for="file in filteredFileListView" :key="file.fullpath" >              
              <td  colspan="3">                
                <div class="file-info float-start" v-if="directoryView"> 
                          <div v-if="file.isDirectory" 
                              v-on:click="setDirectory(file.directory? file.directory + '/' + file.filename: file.filename)" 
                              class="float-start fw-bold"
                              style="cursor:pointer">
                            <i class="fas fa-folder"></i>&nbsp;&nbsp;{{ file.filename }}
                          </div>
                          <div v-if="!file.isDirectory"  class="float-start" >
                            <i v-if="!file.isDirectory" class="far fa-file"></i>&nbsp;&nbsp;&nbsp;{{ file.filename }} 
                          </div>
                </div>
                
                 <!--
                    <img  :title="$t('ZIP.processing')" v-if="file.isDownloading" src="https://www.ezyzip.com/images/loader-tr.svg" alt="Saving" class="float-end" >                                
                  -->
                  <div v-if=" !file.isDownloading" class="file-info float-end">
                      <i  v-on:click="removeFile(file)" class="remove-file float-end fas fa-times "  :title="$t('generic.remove-file')"></i>
                  </div>
                                    
                  <div v-if="!file.isDirectory" style="margin-right:10px;" class=" file-info float-end">{{ file.sizeLabel}}</div>
              </td>
          </tr>           
        </tbody>
    </table>
    </div>
</template>


<script>
//import { checkPasswordError, gaEvent, gaException, saveFile } from '../../services/Utils'
//import { checkPasswordError, gaEvent, gaException, saveFile } from '../../services/Utils'
import FileChooser from './FileChooser.vue'
import filesize from 'filesize'
export default {
  name: 'EditFileList',
  props: {    
    fileList: Array,
    addDirectory: Function,
    addFiles: Function,
    removeFile: Function,    
    editService: Object,
    setCurrentDir: Function
  },
  components: {
    FileChooser
 
  },
  data() {
    return {          
          filteredFileList: [],
          directoryView: true,    
          currentDirParts: [],
          currentDir: '',
          loadingAll: false,
          addDirectoryInput: false,
          newDirectoryName: ''          
       }
  },
  computed: {
        fileListLength() {
            return this.fileList.length;
        },
        fileCount() {
          let count = this.fileList.filter(f => !f.isDirectory).length;          
          return count;
          
        },
        totalFilesSize() {
             let totalSize = this.fileList.reduce((total, file) => total + file.size, 0);           
             return filesize(totalSize);
        },
        filteredFileListView() {
            
          let filtered = Array.from(this.fileList).filter(f => {
            console.log('f.directory', f.directory);
            console.log('this.currentDir', this.currentDir);
            console.log('------------------');
            return f.directory == this.currentDir;
          });
          return filtered.sort((a,b) => {
            if(a.isDirectory > b.isDirectory) {return -1;}
            
            return 0;
          });            
        }

  },
  created() {            
      this.filteredFileList = this.fileList;      
      this.directoryView = true;      
      this.setDirectory(this.currentDir);
  },
  
  methods: {
      setDirectoryPart: function(index) {
        //console.log('set dir part', index);
        let dir = this.currentDirParts.slice(0, index).join('/');
        this.setDirectory(dir);
      },
      setDirectoryView: function(directoryView) {
        //console.log('set to', directoryView);
        this.directoryView = directoryView;
        this.setDirectory('');
      },
      cancelNewDirectory: function() {
        this.addDirectoryInput = false;
        this.newDirectoryName = '';
      },
      addNewDirectory: function() {
        
        this.addDirectoryInput = true;
        
        setTimeout(function () { this.$refs.newDirectoryInput.focus(); }.bind(this), 10);
      },
      submitNewDirectory: function(event) {        
            if (this.currentDir) {
                this.addDirectory(this.currentDir +'/'+ this.newDirectoryName );
            } else {
                this.addDirectory(this.newDirectoryName);
            }
            
            this.addDirectoryInput = false;
            this.newDirectoryName = '';            
            event.preventDefault()
      },      
      setDirectory: function(dir) {
        this.currentDir = dir;                
        this.currentDirParts = dir.split('/');  
        this.setCurrentDir(dir);
      }      
  }
}

</script>
<style scoped>
  
  .remove-file {
    opacity:0.4;
    margin-left:5px;
    margin-right:5px;
    margin-top:3px;
    
  }
  .remove-file:hover {
    opacity:1.0;
    cursor:pointer;
  }
  .folder-input {
    background:transparent;
    border:none;
    color: #fff;
    width: 50%;
    font-weight:bold;
  }
  
  
</style>